import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-a1960s',
  templateUrl: './a1960s.component.html',
  styleUrls: ['./a1960s.component.css']
})
export class A1960sComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
